<template>
  <div class="score-standard">
    <!--面包屑引入-->
    <breadcrumb firstLevel="学校管理">
      <el-button  slot="button" icon="el-icon-plus" @click="showDialog()" type="primary" size="small">新增学生</el-button>
    </breadcrumb>
    <div class="main-wrapper">
      <div class="search-box">
        <el-row :gutter="20">
          <el-col :md="5" :lg="4">
            <el-select id="school" size="small" v-model="school" filterable clearable placeholder="请选择学校"
                       @change="changeSchool" @clear="clearClasses">
              <el-option
                v-for="item in schoolSelectOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-col>
          <el-col :md="5" :lg="4">
            <el-cascader
              size="small"
              style="width:100%;"
              placeholder="选择年级/班级"
              :options="classList"
              :props="props"
              filterable
              clearable
              change-on-select
               @change="classChange"
            ></el-cascader>
          </el-col>
          <el-col :md="5" :lg="4">
            <el-input size="small" v-model="stuName" placeholder="姓名"></el-input>
          </el-col>
          <el-col :md="5" :lg="4">
            <el-select size="small" clearable v-model="genderValue" placeholder="性别">
              <el-option
                v-for="item in genders"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-col>
          <el-col :md="5" :lg="4">
            <el-input size="small" v-model="stuNo" placeholder="学籍号"></el-input>
          </el-col>
          <el-col :md="5" :lg="4">
            <el-button type="primary" size="small" @click="search" @keyup.enter.stop.native="search">查询</el-button>
          </el-col>
        </el-row>
      </div>
      <div class="table-wrapper">
        <el-table
          :data="tableData"
          :height="tableHeight"
          style="width: 100%">
          <el-table-column
            label="编号"
            type="index"
            :width="tdWidth.sm">
          </el-table-column>
          <el-table-column
            label="姓名"
            :width="tdWidth.middle"
          >
            <template slot-scope="scope">
              <div class="tdNormal">{{ scope.row.name}}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="学籍号"
            :width="tdWidth.middle"
          >
            <template slot-scope="scope">
              <div class="tdNormal">{{ scope.row.sno}}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="性别"
            :width="tdWidth.sm"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.sex == 0 ? '男' : '女'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="学校名称"
            :width="tdWidth.large"
          >
            <template slot-scope="scope">
              <div class="tdNormal">{{ scope.row.schoolName}}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="班级"
            :width="tdWidth.middle"
          >
            <template slot-scope="scope">
              <div class="tdNormal">{{ scope.row.classesName}}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="出生日期"
            :width="tdWidth.middle"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.birthday | formatDate}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="入学时间"
            :width="tdWidth.middle"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.goSchoolTime | formatDate}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="家庭住址"
            :width="tdWidth.large"
          >
            <template slot-scope="scope">
              <div class="tdLarge">{{ scope.row.address | fillBlank}}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="家长姓名"
            :width="tdWidth.middle"
          >
            <template slot-scope="scope">
              <div class="tdNormal">{{ scope.row.parentName | fillBlank}}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="联系方式"
            :width="tdWidth.middle"
          >
            <template slot-scope="scope">
              {{ scope.row.phone | fillBlank}}
            </template>
          </el-table-column>
          <el-table-column
            label="备用联系方式"
            :width="tdWidth.middle"
          >
            <template slot-scope="scope">
              {{ scope.row.urgentPhone | fillBlank}}
            </template>
          </el-table-column>
          <el-table-column
            label="备注信息"
            :width="tdWidth.large"
          >
            <template slot-scope="scope">
              <div class="tdLarge">{{ scope.row.remark | fillBlank}}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="时间"
            :width="tdWidth.middle"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.createTime | formatDate}}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="100"
            fixed="right"
            label="操作">
            <template slot-scope="scope">
              <el-button type="text" @click="showDialog(scope.row.id)" size="small">编辑</el-button>
              <el-button type="text" @click="del(scope.row.id)" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination-wapper">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="pageSizes"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="600" @close="handleReset">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item prop="name" label="姓名" :label-width="formLabelWidth">
          <el-input size="small" v-model="form.name" placeholder=""></el-input>
        </el-form-item>
        <el-form-item prop="sno" label="学籍号" :label-width="formLabelWidth">
          <el-input size="small" v-model="form.sno" placeholder=""></el-input>
        </el-form-item>
        <el-form-item prop="genderValue" label="性别" :label-width="formLabelWidth">
          <el-select size="small" clearable v-model="form.genderValue">
              <el-option
                v-for="item in form.genders"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item prop="school" label="学校" :label-width="formLabelWidth">
          <el-select size="small" v-model="form.school" filterable clearable placeholder="请选择学校"
                       @change="changeSchoolForm" @clear="clearClassesForm">
              <el-option
                v-for="item in form.schoolSelectOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
        </el-form-item>
        <el-form-item prop="selectedClass" label="班级" :label-width="formLabelWidth">
          <el-cascader
              size="small"
              style="width:100%;"
              placeholder="选择年级/班级"
              :options="form.classList"
              :props="props"
              v-model="form.selectedClass"
              filterable
              clearable
              change-on-select
              @change="classChangeForm"
            ></el-cascader>
        </el-form-item>
        <el-form-item prop="goSchoolTime" label="入学时间" :label-width="formLabelWidth">
          <el-date-picker
            size="small"
            v-model="form.goSchoolTime"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="birthday" label="出生日期" :label-width="formLabelWidth">
          <el-date-picker
            size="small"
            v-model="form.birthday"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="家庭住址" :label-width="formLabelWidth">
          <el-input size="small" v-model="form.address" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="家长姓名" :label-width="formLabelWidth">
          <el-input size="small" v-model="form.parentName" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item prop="phone" label="联系方式1" :label-width="formLabelWidth">
          <el-input size="small" v-model="form.phone" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item prop="urgentPhone" label="联系方式2" :label-width="formLabelWidth">
          <el-input size="small" v-model="form.urgentPhone" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item prop="remark" label="备注" :label-width="formLabelWidth">
           <el-input size="small" type="textarea" v-model="form.remark" placeholder="请输入38个以内个字符"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="addOrUpdate('form')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import Breadcrumb from '@/base/breadcrumb/breadcrumb'
  import {setTableHeight, tdWidth} from 'common/js/dom'
  import {baseUrl, ERR_OK, pageSize, pageSizes} from 'common/api/api'
  import {formatDate} from 'common/js/date'
  import {fillBlank} from 'common/js/fillBlank'
  import $ from 'jquery'

  export default {
    data() {
      var validateClass = (rule, value, callback) => {
        if (value.length === 1) {
          callback(new Error('请选择班级'))
        } else {
          callback()
        }
      }
      var validatePhone = (rule, value, callback) => {
        if (value) {
          let reg = /^((17[0-9])|(14[0-9])|(13[0-9])|(15[^4,\\D])|(18[0,5-9]))\d{8}$/
          let result = reg.test(value)
          if (result) {
            callback()
          } else {
            callback(new Error('请输入正确的手机号码格式'))
          }
        } else {
          callback()
        }
      }
      return {
        schoolId: '',
        api: {
          list: '/studentnew/list/info',
          schoolListUrl: '/api/common/user/schools',
          classes: '/api/system/org/query/info',
          del: '/studentnew/delete/by/id',
          add: '/studentnew/insert/info',
          update: '/studentnew/update/info',
          addOrUpdate: '',
          getInfo: '/student/get/by/id'
        },
        tdWidth: tdWidth,
        dialogTitle: '新增学生',
        infoId: '',
        addSubmit: true,
        firstSchool: '',
        genders: [{
          value: '0',
          label: '男生'
        }, {
          value: '1',
          label: '女生'
        }],
        genderValue: '',
        schoolSelectOptions: [],
        school: '',
        checkedSchoolObj: '',
        classList: [],
        gradeOrgId: '',
        classesOrgId: '',
        stuName: '',
        stuNo: '',
        dialogFormVisible: false,
        form: {
          name: '',
          sno: '',
          genders: [{
            value: 0,
            label: '男生'
          }, {
            value: 1,
            label: '女生'
          }],
          genderValue: '',
          schoolSelectOptions: [],
          school: '',
          checkedSchoolObj: '',
          classList: [],
          gradeOrgId: '',
          classesOrgId: '',
          selectedClass: [],
          goSchoolTime: '',
          birthday: '',
          address: '',
          parentName: '',
          phone: '',
          urgentPhone: '',
          remark: ''
        },
        props: {
          label: 'name',
          value: 'id',
          children: 'children'
        },
        rules: {
          name: [
            {required: true, message: '请输入学生姓名', trigger: 'blur'}
          ],
          sno: [
            {required: true, message: '请输入学籍号', trigger: 'blur'}
          ],
          genderValue: [
            {required: true, message: '请选择性别', trigger: 'change'}
          ],
          school: [
            {required: true, message: '请选择学校', trigger: 'change'}
          ],
          goSchoolTime: [
            {required: true, message: '请输入入学时间', trigger: 'blur'}
          ],
          birthday: [
            {required: true, message: '请输入出生日期', trigger: 'blur'}
          ],
          selectedClass: [
            {required: true, message: '请输入班级', trigger: 'change'},
            {validator: validateClass, trigger: 'change'}
          ],
          phone: [
            {validator: validatePhone, trigger: 'blur'}
          ],
          urgentPhone: [
            {validator: validatePhone, trigger: 'blur'}
          ],
          remark: [
            {min: 0, max: 38, message: '长度不能超过38个字符', trigger: 'blur'}
          ]
        },
        formLabelWidth: '90px',
        tableHeight: undefined,
        currentPage: 1,
        total: 0,
        pageSize: pageSize,
        pageSizes: pageSizes,
        tableData: []
      }
    },
    components: {
      Breadcrumb
    },
    filters: {
      formatDate(time) {
        if (time) {
          let date = new Date(time)
          return formatDate(date, 'yyyy-MM-dd')
        } else {
          return '--'
        }
      },
      fillBlank(str) {
        if (str) {
          if (str.length > 38) {
            str = str.substring(0, 38) + '...'
          }
        }
        return fillBlank(str)
      }
    },
    methods: {
      handleSizeChange(val) {
        this.pageSize = val
        if (this.school) {
          this.otherSchool()
        } else {
          this.getList()
        }
      },
      handleCurrentChange(val) {
        this.currentPage = val
        if (this.school) {
          this.otherSchool()
        } else {
          this.getList()
        }
      },
      otherSchool() {
        this.$http({
          method: 'POST',
          url: baseUrl + this.api.list,
          body: JSON.stringify({
            'pageNumber': this.currentPage,
            'pageSize': this.pageSize,
            'schoolOrgId': this.school,
            'classesOrgId': this.classesOrgId,
            'gradeOrgId': this.gradeOrgId,
            'name': this.stuName,
            'sex': this.genderValue,
            'sno': this.stuNo
          }),
          _timeout: 6000,
          onTimeout: (request) => {
          }
        }).then((res) => {
          let response = res.body
          if (response.code === ERR_OK) {
            let data = response.data
            this.tableData = data.list
            this.total = data.total
          }
        }).catch((err) => {
          console.error(err)
        })
      },
      handleReset() {
        // 清空表单
        this.$refs['form'].resetFields()
        this.form.address = ''
        this.form.parentName = ''
        this.form.phone = ''
        this.form.urgentPhone = ''
        this.form.remark = ''
      },
      showDialog(flag) {
        // flag false 新增  true '编辑'
        this.dialogFormVisible = true
        if (!flag) {
          this.dialogTitle = '新增学生'
          this.infoId = ''
          this.addSubmit = true
        } else {
          this.dialogTitle = '编辑学生'
          this.infoId = flag
          this.addSubmit = false
          this.getInfo(flag)
        }
      },
      // 编辑回显
      getInfo(id) {
        this.$http({
          method: 'POST',
          url: baseUrl + this.api.getInfo,
          params: {
            'id': id
          },
          _timeout: 6000,
          onTimeout: (request) => {
          }
        }).then((res) => {
          let response = res.body
          if (response.code === ERR_OK) {
            let data = response.data
            this.form.name = data.name
            this.form.sno = data.sno
            this.form.genderValue = data.sex
            this.form.school = data.schoolOrgId
            this.getClassListForm(data.schoolOrgId)
            this.form.selectedClass = [data.gradeOrgId, data.classesOrgId]
            this.form.goSchoolTime = data.goSchoolTime
            this.form.birthday = data.birthday
            this.form.address = data.address
            this.form.parentName = data.parentName
            this.form.phone = data.phone
            this.form.urgentPhone = data.urgentPhone
            this.form.remark = data.remark
          }
        }).catch((err) => {
          console.error(err)
        })
      },
      // 提交按钮
      addOrUpdate(formName) {
        if (this.addSubmit) {
          this.api.addOrUpdate = this.api.add
        } else {
          this.api.addOrUpdate = this.api.update
        }
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$http({
              method: 'POST',
              url: baseUrl + this.api.addOrUpdate,
              body: JSON.stringify({
                'id': this.infoId,
                'name': this.form.name,
                'sno': this.form.sno,
                'sex': this.form.genderValue,
                'classesOrgId': this.form.selectedClass[1],
                'gradeOrgId': this.form.selectedClass[0],
                'goSchoolTime': this.form.goSchoolTime,
                'birthday': this.form.birthday,
                'address': this.form.address,
                'parentName': this.form.parentName,
                'phone': this.form.phone,
                'urgentPhone': this.form.urgentPhone,
                'remark': this.form.remark
              }),
              _timeout: 6000,
              onTimeout: (request) => {
              }
            }).then((res) => {
              let response = res.body
              if (response.code === ERR_OK) {
                this.$message({
                  message: '恭喜你，操作成功',
                  type: 'success'
                })
                this.dialogFormVisible = false
                this.getList()
              }
            }).catch((err) => {
              console.error(err)
            })
          } else {
            return false
          }
        })
      },
      del(id) {
        this.$confirm('此操作将永久删除该学生信息, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http({
            method: 'POST',
            url: baseUrl + this.api.del,
            params: {
              'id': id
            },
            _timeout: 6000,
            onTimeout: (request) => {
            }
          }).then((res) => {
            let response = res.body
            if (response.code === ERR_OK) {
              this.getList()
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
            }
          }).catch((err) => {
            console.error(err)
          })
        }).catch(() => {
        })
      },
      search() {
        this.currentPage = 1
        this.$http({
          method: 'POST',
          url: baseUrl + this.api.list,
          body: JSON.stringify({
            'pageNumber': this.currentPage,
            'pageSize': this.pageSize,
            'schoolOrgId': this.school == '' ? this.schoolId : this.school, // eslint-disable-line
            'classesOrgId': this.classesOrgId,
            'gradeOrgId': this.gradeOrgId,
            'name': this.stuName,
            'sex': this.genderValue,
            'sno': this.stuNo
          }),
          _timeout: 6000,
          onTimeout: (request) => {
          }
        }).then((res) => {
          let response = res.body
          if (response.code === ERR_OK) {
            let data = response.data
            this.tableData = data.list
            this.total = data.total
          }
        }).catch((err) => {
          console.error(err)
        })
      },
      getList() {
        this.$http({
          method: 'POST',
          url: baseUrl + this.api.list,
          body: JSON.stringify({
            'pageNumber': this.currentPage,
            'pageSize': this.pageSize,
            'schoolOrgId': this.schoolId,
            'classesOrgId': this.classesOrgId,
            'gradeOrgId': this.gradeOrgId,
            'name': this.stuName,
            'sex': this.genderValue,
            'sno': this.stuNo
          }),
          _timeout: 6000,
          onTimeout: (request) => {
          }
        }).then((res) => {
          let response = res.body
          if (response.code === ERR_OK) {
            let data = response.data
            this.tableData = data.list
            this.total = data.total
          }
        }).catch((err) => {
          console.error(err)
        })
      },
      /* 获取学校列表 */
      getSchools() {
        this.$http({
          method: 'post',
          emulateJSON: true,
          url: baseUrl + this.api.schoolListUrl
        }).then((res) => {
          if (res.body.code === ERR_OK) {
            this.schoolSelectOptions = res.body.data
            this.form.schoolSelectOptions = res.body.data
            this.schoolId = res.body.data[0].id
            this.$http({
              method: 'POST',
              url: baseUrl + this.api.list,
              body: JSON.stringify({
                'pageNumber': this.currentPage,
                'pageSize': this.pageSize,
                'schoolOrgId': this.schoolId,
                'classesOrgId': this.classesOrgId,
                'gradeOrgId': this.gradeOrgId,
                'name': this.stuName,
                'sex': this.genderValue,
                'sno': this.stuNo
              }),
              _timeout: 6000,
              onTimeout: (request) => {
              }
            }).then((res) => {
              let response = res.body
              if (response.code === ERR_OK) {
                let data = response.data
                this.tableData = data.list
                this.total = data.total
              }
            }).catch((err) => {
              console.error(err)
            })
          }
        }, (res) => {
          console.error(res)
        })
      },
      /* 选择学校 */
      changeSchool(value) {
        this.getClassList(value)
      },
      /* 选择学校  表单 */
      changeSchoolForm(value) {
        this.getClassListForm(value)
      },
      // 清空
      clearClasses() {
        this.classList = []
        this.gradeOrgId = ''
        this.classesOrgId = ''
      },
      // 清空 表单
      clearClassesForm() {
        this.form.classList = []
        this.selectedClass = []
        this.form.gradeOrgId = ''
        this.form.classesOrgId = ''
      },
      // 班级下拉
      getClassList(id) {
        this.$http({
          method: 'GET',
          url: baseUrl + this.api.classes,
          params: {
            'id': id
          },
          _timeout: 6000,
          onTimeout: (request) => {
          }
        }).then((res) => {
          let response = res.body
          if (response.code === ERR_OK) {
            let data = response.data.children
            if (data.length > 0) {
              $.each(data, function (i, item) {
                if (item.children.length > 0) {
                  $.each(item.children, function (i, item) {
                    delete item.children
                  })
                }
              })
            }
            this.classList = data
          }
        }).catch((err) => {
          console.error(err)
        })
      },
      // 班级下拉 表单
      getClassListForm(id) {
        this.$http({
          method: 'GET',
          url: baseUrl + this.api.classes,
          params: {
            'id': id
          },
          _timeout: 6000,
          onTimeout: (request) => {
          }
        }).then((res) => {
          let response = res.body
          if (response.code === ERR_OK) {
            let data = response.data.children
            if (data.length > 0) {
              $.each(data, function (i, item) {
                if (item.children.length > 0) {
                  $.each(item.children, function (i, item) {
                    delete item.children
                  })
                }
              })
            }
            this.form.classList = data
          }
        }).catch((err) => {
          console.error(err)
        })
      },
      classChange(val) {
        [this.gradeOrgId, this.classesOrgId] = val
      },
      classChangeForm(val) {
        this.form.selectedClass = val
        this.form.gradeOrgId = val[0]
        this.form.classesOrgId = val[1]
      }
    },
    mounted() {
      this.tableHeight = setTableHeight('table-wrapper')
      window.onresize = () => {
        this.tableHeight = setTableHeight('table-wrapper')
      }
      // 学校下拉
      this.getSchools()
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .score-standard {
    height: 100%;
    .table-wrapper {
      height: -webkit-calc(100% - (98px));
      height: -moz-calc(100% - (98px));
      height: calc(100% - (98px));
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/students/students-list.vue